<template>
<div>
  <div class="row">
    <div class="col-md-12">
      <span>
        Cadastre imagens para exibir na galeria do projeto. Limite de até 9 fotos.
      </span>
    </div>
  </div>
  <div class="row" v-if="showMsg || showMsgSuccess">
    <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
      {{msg}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div v-if="showMsgSuccess" class="alert alert-success alert-dismissible fade show" role="alert">
      {{msgSuccess}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" v-on:click.stop.prevent="hideMsg()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="row pictures" v-if="images">
    <div class="col-md-3" v-for="(i, k) in images" :key="k">
      <img @click="removeImage(i.ImageId)" :src="i.url"/>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <button class="btn" @click.stop.prevent="selectImage()">Adicionar Imagem</button>
      <input ref="uploadBtnImage" class="input-image" type="file" @change="uploadImage" />
    </div>
  </div>

</div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'

export default {
  name: 'ProjectImages',
  props: ['project'],
  components: {

  },
  data(){
    return {
      msg: '',
      showMsg: false,
      msgSuccess: '',
      showMsgSuccess: false,
      images: null,
    }
  },
  mounted(){
    this.projectId = this.project.ProjectId;
    if(this.project.Images){
      this.images = this.project.Images
    }
  },
  methods: {
    uploadImage(e){
      e.preventDefault();
      if(!this.images || (this.images && this.images.length < 9)){
        this.$emit('showloading');
        this.isUploadingPicture = true;
        var file = e.target.files[0]
        var reader = new FileReader();
        var $this = this;
        reader.addEventListener('loadend', (e) => {
          $this.$http.post(API.Projects.updateProject + this.projectId, {page: 'uploadImage', action: 'insert', fileName: file.name, fileType: file.type}, {headers: auth.getHeaders()})
          .then((res) => {
            if(res.body.success == false){
              return false;
            }else{
              return $this.$http.put(res.body.uploadUrl, new Blob([reader.result], {type: file.type}), {headers: {'Content-Type': file.type, 'x-amz-acl': 'authenticated-read'}});
            }
          })
          .then((res) => {
            if(res){
              $this.$emit('reload');
              var image = res.url.split('?');
              image = image[0] + '?' + new Date().getTime();
              var idTemp = image.split('images/');
              var id = idTemp[1].split('.jpg');
              id = id[0];
              if(!$this.images){
                $this.images = [];
              }
              $this.images.push({ImageId: id, url: image});
            }else{
              $this.$emit('hideloading');
              this.msg = 'Erro ao carregar imagem.';
              this.showMsg = true;
            }
          })
        })
        reader.readAsArrayBuffer(file);
      }else{
        this.msg = 'Você atingiu o limite de imagens.';
        this.showMsg = true;
      }
    },
    removeImage(id){
      var r = confirm("Deseja remover essa imagem?");
      if(r == true){
        this.$emit('showloading');
        this.$http.post(API.Projects.updateProject + this.projectId, {page: 'uploadImage', ImageId: id, action: 'delete'}, 
        {headers: auth.getHeaders()}).then((res) => {
            if(res.body.success === true){
              this.successMsg = res.body.message;
              this.showSuccessMsg = true;
              this.images = this.images.filter((a) => {
                return a.ImageId !== id
              })
            }else{
              this.msg = res.body.message;
              this.showMsg = true;
            }
            this.$emit('hideloading');
          }, (err) => {
            this.$emit('hideloading');
            this.msg = err.body.message;
            this.showMsg = true;
          });
      }
    },
    selectImage(){
      if(!this.image || (this.images && this.images.length < 9)){
        this.$refs.uploadBtnImage.click();
      }else{
        this.msg = 'Você atingiu o limite de imagens.';
        this.showMsg = true;
      }
    },
    hideMsg(){
      this.msg = "";
      this.msgSuccess = "";
      this.showMsg = false;
      this.showMsgSuccess = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.alert-success, .alert-danger{
  width: 100%;
}
h4{
  color: #00AE39;
  margin-bottom: 1px;
}
span{
  font-size: 15px;
}
.projects-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}
.form-config{
    margin-top: 20px;
    .row{
      padding: 20px;
      border-bottom: thin solid #eee;
      &:last-child{
        border-bottom: none;
      }
    }
    .btn{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &.clear-project{
        background-color: red;
      }
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
}
.pictures{
  img{
    margin-top: 10px;
    width: 100%;
    cursor: pointer;
  }
}

.input-image{
  display: none;
}
.activity{
  padding: 10px;
  background-color: #eee;
  margin-top: 20px;
  border-radius: 5px;
  font-size: 14px;
  display: block;
  position: relative;
  h5{
    font-family: RalewayBold;
    padding-bottom: 10px;
  }
  .btn{
    font-size: 14px;
    background-color: red;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  span{
    font-size: 12px;
    color: #999;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/manage-project/Images.vue